import { cn } from '@/helpers/utils'

export interface StatCardProps {
	value: string
	/** Muted suffix rendered after the value, e.g. the "/42" in "37/42". */
	valueSuffix?: string
	label: string
	sublabel?: string
	/** Layout classes set by the container (e.g. `l:flex-1` or a fixed width). */
	className?: string
}

/**
 * A single stat tile: a bold value (with an optional muted suffix) over a
 * label and caption. Layout-agnostic — the container decides sizing (equal
 * columns on the check-in tab, fixed-width scroll items on the attendee row).
 */
export function StatCard({
	value,
	valueSuffix,
	label,
	sublabel,
	className
}: StatCardProps) {
	return (
		<div
			className={cn(
				'flex flex-row l:flex-col l:items-start items-baseline gap-2 l:gap-1 rounded-lg border border-grey-400 bg-neutral-white p-4',
				className
			)}
		>
			<span className='font-semibold text-grey-1000 text-lg leading-6'>
				{value}
				{valueSuffix && (
					<span className='font-medium text-neutral-500'>
						{valueSuffix}
					</span>
				)}
			</span>
			<div className='flex min-w-0 flex-col'>
				<span className='text-neutral-700 text-sm'>{label}</span>
				{sublabel && (
					<span className='text-neutral-500 text-xs'>{sublabel}</span>
				)}
			</div>
		</div>
	)
}
